<template>
    <div>
        <div class="screen_media bg_eef1fa pa_top_10">
            <div class="main bg_fff">
                <div class="login">
                    <h2>创建账户</h2>
                    <form method="post" onsubmit="return false;">
                        <div class="login_input flex_start">
                            <input type="text" name="username" v-model="username" placeholder="请输入用户名" />
                            <img src="@/assets/images/account.png"/>
                        </div>
                        <div class="drag"
                             ref="dragDiv">
                            <div class="drag_bg"></div>
                            <div class="drag_text">{{confirmWords}}</div>
                            <div ref="moveDiv"
                                 @mousedown="mousedownFn($event)"
                                 :class="{'handler_ok_bg':confirmSuccess}"
                                 class="handler handler_bg"
                                 style="position: absolute;top: 0px;left: 0px;"></div>
                        </div>
                        <div class="login_input flex_start">
                            <input type="password" name="password" v-model="password" placeholder="请输入密码（长度8-18位字母+数字）" />
                            <img src="@/assets/images/password.png"/>
                        </div>
                        <div class="login_input flex_start">
                            <input type="password" name="again_password" v-model="again_password" placeholder="请输入确认密码" />
                            <img src="@/assets/images/password.png"/>
                        </div>

                        <div class="register_agree flex_center align_items_center">
                            <input type="checkbox" name="agree" value="1" @click="agreeBtn(event)" />
                            <span>同意并遵守</span>
                            <a href="/home/detail" target="_blank">《中国科学技术出版社有限公司服务网络服务使用协议》</a>
                        </div>

                        <button type="submit" @click="submitBtn">立即注册</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                beginClientX: 0, /* 距离屏幕左端距离 */
                mouseMoveStata: false, /* 触发拖动状态  判断 */
                maxwidth: '', /* 拖动最大宽度，依据滑块宽度算出来的 */
                confirmWords: '拖动滑块验证', /* 滑块文字 */
                confirmSuccess: false, /* 验证成功判断 */
                username:'',
                password:'',
                again_password:'',
                agree:false
            }
        },
        created() {
            let _this = this;
            if(localStorage.getItem('user_id'))
            {
                layer.msg('您已登录，正在为你跳转');
                setTimeout(function () {
                    _this.$router.push({
                        path: '/my/index'
                    })
                },1000);
                return false;
            }
        },
        methods: {
            agreeBtn: function(e){
                let _this = this,
                    agree = _this.agree;
                if(agree === false)
                {
                    _this.agree = true;
                } else {
                    _this.agree = false;
                }
            },
            submitBtn: function(){
                let _this = this,
                    username = _this.username,
                    password = _this.password,
                    again_password = _this.again_password,
                    agree = _this.agree,
                    confirmSuccess = _this.confirmSuccess;
                if(confirmSuccess === false)
                {
                    layer.msg('请先完成验证');
                    return false;
                }
                if(agree === false)
                {
                    layer.msg('请先阅读协议');
                    return false;
                }
                this.$http({
                    url: 'user/register',
                    method: 'post',
                    headers: {"Content-Type": "multipart/form-data"},
                    data:{account:username,password:password,again_password:again_password}
                }).then(res => {
                    if(res.data.code == 1) {
                        localStorage.setItem('user_id',res.data.data.userinfo.id);
                        localStorage.setItem('user_username',res.data.data.userinfo.username);
                        localStorage.setItem('user_nickname',res.data.data.userinfo.nickname);
                        localStorage.setItem('user_avatar',res.data.data.userinfo.avatar);
                        localStorage.setItem('user_token',res.data.data.userinfo.token);
                        setTimeout(function () {
                            _this.$router.push({
                                path: '/my/index'
                            })
                        },1500);
                    }
                    layer.msg(res.data.msg);
                });
            },
            mousedownFn: function (e) {
                if (!this.confirmSuccess) {
                    e.preventDefault && e.preventDefault() // 阻止文字选中等 浏览器默认事件
                    this.mouseMoveStata = true
                    this.beginClientX = e.clientX
                }
            }, // mousedoen 事件
            successFunction () {
                this.confirmSuccess = true
                this.confirmWords = '验证通过'
                if (window.addEventListener) {
                    document.getElementsByTagName('html')[0].removeEventListener('mousemove', this.mouseMoveFn)
                    document.getElementsByTagName('html')[0].removeEventListener('mouseup', this.moseUpFn)
                } else {
                    document.getElementsByTagName('html')[0].removeEventListener('mouseup', () => { })
                }
                document.getElementsByClassName('drag_text')[0].style.color = '#00c47d'
                document.getElementsByClassName('handler')[0].style.left = this.maxwidth + 'px'
                document.getElementsByClassName('drag_bg')[0].style.width = this.maxwidth + 'px'
            }, // 验证成功函数
            mouseMoveFn (e) {
                if (this.mouseMoveStata) {
                    let width = e.clientX - this.beginClientX
                    if (width > 0 && width <= this.maxwidth) {
                        document.getElementsByClassName('handler')[0].style.left = width + 'px'
                        document.getElementsByClassName('drag_bg')[0].style.width = width + 'px'
                    } else if (width > this.maxwidth) {
                        this.successFunction()
                    }
                }
            }, // mousemove事件
            moseUpFn (e) {
                this.mouseMoveStata = false
                var width = e.clientX - this.beginClientX
                if (width < this.maxwidth) {
                    document.getElementsByClassName('handler')[0].style.left = 0 + 'px'
                    document.getElementsByClassName('drag_bg')[0].style.width = 0 + 'px'
                }
            } // mouseup事件
        },
        mounted () {
            this.maxwidth = this.$refs.dragDiv.clientWidth - this.$refs.moveDiv.clientWidth
            document.getElementsByTagName('html')[0].addEventListener('mousemove', this.mouseMoveFn)
            document.getElementsByTagName('html')[0].addEventListener('mouseup', this.moseUpFn)
        }
    }
</script>

<style scoped>
    .pa_top_10{padding-top:10px;}
    .screen_media{width: 100%;padding-bottom: 45px;}
    .login{width:402px;text-align: center;display: block;margin:0 auto;padding:70px 0 100px;}
    .login h2{width: 100%;font-size: 36px;line-height: 36px;color:#000;font-weight: normal;display: block;}
    .login_input,.login button{width:402px;height: 60px;display: block;margin-top:20px;}
    .login_input {border:1px solid #dcdcdc;line-height: 58px;font-size:14px;}
    .login_input img{width: 20px;height: 22px;object-fit: contain;display: block;margin:18px 15px 18px 20px;}
    .login_input input{height: 58px;line-height: 58px;border:none;width: calc(100% - 55px);display: block;padding:0 20px;}
    .login button{background: #5e8dee;color:#fff;text-align: center;font-size:20px;line-height: 60px;display: block;border:none;}
    .login p{width: 100%;display: block;text-align: right;font-size:14px;line-height: 20px;color:#666;}
    .login p a{color:#5e8dee;display: inline-block;margin-top:10px;}
    .register_agree input[type=checkbox]{width: 14px;height: 14px;margin-right: 5px;}
    .register_agree{font-size:14px;line-height: 20px;color:#666;margin:20px 0 0;}
    .register_agree a{color:#76a7fc;}

    .drag {
        position: relative;
        background-color: #e8e8e8;
        width: 100%;
        height: 60px;
        line-height: 58px;
        text-align: center;
        margin-top:20px;
        border:1px solid #dcdcdc;
    }
    .handler {
        width: 58px;
        height: 58px;
        /*border: 1px solid #ccc;*/
        cursor: move;
    }
    .handler_bg {
        background: #fff
        url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NTEyNTVEMURGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NTEyNTVEMUNGMkVFMTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDo2MTc5NzNmZS02OTQxLTQyOTYtYTIwNi02NDI2YTNkOWU5YmUiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YiRG4AAAALFJREFUeNpi/P//PwMlgImBQkA9A+bOnfsIiBOxKcInh+yCaCDuByoswaIOpxwjciACFegBqZ1AvBSIS5OTk/8TkmNEjwWgQiUgtQuIjwAxUF3yX3xyGIEIFLwHpKyAWB+I1xGSwxULIGf9A7mQkBwTlhBXAFLHgPgqEAcTkmNCU6AL9d8WII4HOvk3ITkWJAXWUMlOoGQHmsE45ViQ2KuBuASoYC4Wf+OUYxz6mQkgwAAN9mIrUReCXgAAAABJRU5ErkJggg==')
        no-repeat center;
    }
    .handler_ok_bg {
        background: #fff
        url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3hpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDIxIDc5LjE1NTc3MiwgMjAxNC8wMS8xMy0xOTo0NDowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDo0ZDhlNWY5My05NmI0LTRlNWQtOGFjYi03ZTY4OGYyMTU2ZTYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6NDlBRDI3NjVGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6NDlBRDI3NjRGMkQ2MTFFNEI5NDBCMjQ2M0ExMDQ1OUYiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTQgKE1hY2ludG9zaCkiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDphNWEzMWNhMC1hYmViLTQxNWEtYTEwZS04Y2U5NzRlN2Q4YTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6NGQ4ZTVmOTMtOTZiNC00ZTVkLThhY2ItN2U2ODhmMjE1NmU2Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+k+sHwwAAASZJREFUeNpi/P//PwMyKD8uZw+kUoDYEYgloMIvgHg/EM/ptHx0EFk9I8wAoEZ+IDUPiIMY8IN1QJwENOgj3ACo5gNAbMBAHLgAxA4gQ5igAnNJ0MwAVTsX7IKyY7L2UNuJAf+AmAmJ78AEDTBiwGYg5gbifCSxFCZoaBMCy4A4GOjnH0D6DpK4IxNSVIHAfSDOAeLraJrjgJp/AwPbHMhejiQnwYRmUzNQ4VQgDQqXK0ia/0I17wJiPmQNTNBEAgMlQIWiQA2vgWw7QppBekGxsAjIiEUSBNnsBDWEAY9mEFgMMgBk00E0iZtA7AHEctDQ58MRuA6wlLgGFMoMpIG1QFeGwAIxGZo8GUhIysmwQGSAZgwHaEZhICIzOaBkJkqyM0CAAQDGx279Jf50AAAAAABJRU5ErkJggg==')
        no-repeat center;
    }
    .drag_bg {
        background-color: #eff9ff;
        height: 58px;
        width: 0px;
    }
    .drag_text {
        position: absolute;
        top: 0px;
        width: 100%;
        text-align: center;
        -moz-user-select: none;
        -webkit-user-select: none;
        user-select: none;
        -o-user-select: none;
        -ms-user-select: none;
    }

    @media screen and (max-width: 1240px) {
        .login{width: 100%;max-width: 402px;padding:5.645vw 0 8.0645vw;}
        .login_input,.login button{width:100%;}
    }
    @media screen and (max-width: 440px) {
        .login_input,.login button,.drag{width:96%;margin-left:2%;}
        .register_agree{flex-wrap: wrap;}
    }
</style>



// WEBPACK FOOTER //
// src/pages/my/register.vue